export const DEFAULT_DROPDOWN_MAX_HEIGHT = 400;
export const DEFAULT_DROPDOWN_FILTER_WITH_FILTER_MIN_HEIGHT = 106;
export const DEFAULT_DROPDOWN_FILTER_MIN_HEIGHT = 63;
export const DEFAULT_DROPDOWN_FILTER_MIN_WIDTH = 160;
export const DEFAULT_DROPDOWN_MULTI_SELECT_MAX_HEIGHT = 408;

export const DROPDOWN_FILTER_VALUE_GAP = 8;
export const DROPDOWN_FILTER_VALUE_DIVIDER_LENGTH = 16;
export const DROPDOWN_FILTER_LABEL_GAP = 4;
